import { v4 as uuidv4 } from 'uuid';
import { Wishlist } from '../../../../vtex-apps/peer/wishlist/Wishlist/default';
import { StackLayout } from '../../../../vtex-apps/stack-layout/StackLayout/default';
import { ProductSummaryName } from '../../../../vtex-apps/product-summary/ProductSummaryName/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ProductListPrice } from '../../../../vtex-apps/product-price/ProductListPrice/default';
import { ProductSellingPrice } from '../../../../vtex-apps/product-price/ProductSellingPrice/default';
import { ProductInstallments } from '../../../../vtex-apps/product-price/ProductInstallments/default';
import { AddToCartButton } from '../../../../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { ProductHighlights } from '../../../../vtex-apps/product-highlights/ProductHighlights/default';
import { ProductSummaryImage } from '../../../../vtex-apps/product-summary/ProductSummaryImage/default';
import { ProductRatingInline } from '../../../../vtex-apps/peer/reviews-and-ratings/ProductRatingInline/default';
import { ConditionLayoutProduct } from '../../../../vtex-apps/ConditionLayoutProduct/default';

export default function ProductSummaryShelf() {
	return {
		componentName: 'ProductSummaryShelfComponent',
		componentId: uuidv4(),
		componentGroup: 'ProductSummaryShelf',
		variables,
		props: {
			blockClass: 'product-list__summary-2',
		},
		childrenComponents: [
			Wishlist({ blockClass: 'product-shelf__wishlist-2' }),
			FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-shelf__row-2' }, [
				StackLayout(
					{
						blockClass: 'product-list__shelf-2',
					},
					[
						ProductSummaryImage({ blockClass: 'product-list__image-2', maxHeight: 500 }),
						ProductHighlights({ blockClass: 'product-list-2' }),
					],
				),
				FlexLayoutRow({ blockClass: 'shelf__product-name-wrapper-2', colSizing: '100%' }, [
					ProductSummaryName({
						blockClass: 'product-summary__name-2',
						showFieldsProps: {
							showSku: false,
							showProductReference: false,
							showBrandName: true,
						},
					}),
				]),
				ProductRatingInline(),
				ConditionLayoutProduct({
					conditions: [{ subject: 'isProductAvailable' }],
					Then: FlexLayoutRow(
						{
							blockClass: 'shelf__flex-row-2',
							colSizing: 'auto',
							horizontalAlign: 'left',
						},
						[
							ProductListPrice({
								blockClass: 'product-shelf__list-price-2',
							}),
							ProductSellingPrice({
								blockClass: 'product-shelf__selling-price-2',
							}),
							ProductInstallments({
								blockClass: 'product-shelf__installments-2',
							}),
						],
					),
					Else: null,
				}),
				AddToCartButton({
					unavailableText: 'Indisponível',
					customToastUrl: '/',
					text: 'Ver Detalhes',
					blockClass: 'summary__add-to-cart-btn',
					onClickBehavior: 'go-to-product-page',
				}),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--cta-color-pure', to: '--shelf-2-highlight-color', name: 'Highlight' },
			{ from: '--white', to: '--shelf-2-highlight-text-color', name: 'Highlight Text' },
			{ from: '--brand-color-secondary-pure', to: '--shelf-2-discount-color', name: 'Discount Flag' },
			{ from: '--white', to: '--shelf-2-discount-text-color', name: 'Discount Flag Text' },
			{ from: '--text-color-1', to: '--shelf-2-text-color', name: 'Text' },
			{ from: '--neutral-color-high-medium', to: '--shelf-2-border-color', name: 'Shelf Border' },
			{ from: '--text-color-1', to: '--shelf-2-installments-color', name: 'Installments' },
			{ from: '--text-color-1', to: '--shelf-2-installments-value-color', name: 'Installments Value' },
			{ from: '--text-color-1-light', to: '--shelf-2-list-price-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--shelf-2-price-color', name: 'SellingPrice' },

			{ from: '--brand-color-primary-pure', to: '--shelf-2-reviews-color', name: 'Reviews' },
			{ from: '--white', to: '--shelf-2-text-cta-color', name: 'CTA Text' },
			{ from: '--cta-color-pure', to: '--shelf-2-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--shelf-2-cta-color-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--shelf-2-cta-color-focus', name: 'CTA Focus' },

			{ from: '--brand-color-primary-pure', to: '--shelf-2-wishlist', name: 'wishlist icon' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--shelf-2-border-radius', name: 'Shelf' },
			{ from: '--border-radius-sm', to: '--shelf-2-cta-border-radius', name: 'CTA' },
			{ from: '--border-radius-sm', to: '--shelf-2-highlight-border-radius', name: 'Highlight' },
		],
	},
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--shelf-2-border-width', name: 'Shelf' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxxs', to: '--shelf-2-highlight-font-size', name: 'Highlight' },
			{ from: '--font-size-xxxs', to: '--shelf-2-discount-fs', name: 'Discount' },
			{ from: '--font-size-xs', to: '--shelf-2-name-font-size', name: 'Product Name' },
			{ from: '--font-size-lg', to: '--shelf-2-reviews-font-size', name: 'Reviews Stars' },
			{ from: '--font-size-sm', to: '--shelf-2-list-font-size', name: 'List Price' },
			{ from: '--font-size-lg', to: '--shelf-2-selling-font-size', name: 'Selling Price' },
			{ from: '--font-size-sm', to: '--shelf-2-installments-font-size', name: 'Installments Text' },
			{ from: '--font-size-xs', to: '--shelf-2-installments-value-font-size', name: 'Installments Values' },
			{ from: '--font-size-sm', to: '--shelf-2-cta-font-size', name: 'CTA' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--shelf-2-hightlight-fw', name: 'Highlight' },
			{ from: '--font-weight-700', to: '--shelf-2-discount-fw', name: 'Discount' },
			{ from: '--font-weight-700', to: '--shelf-2-name-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--shelf-2-list-fw', name: 'List Price' },
			{ from: '--font-weight-400', to: '--shelf-2-selling-fw', name: 'Selling Price' },
			{ from: '--font-weight-400', to: '--shelf-2-installments-fw', name: 'Installments Text' },
			{ from: '--font-weight-700', to: '--shelf-2-installments-value-fw', name: 'Installments Values' },
			{ from: '--font-weight-700', to: '--shelf-2-cta-fw', name: 'CTA' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--shelf-2-highlight-typography', name: 'Highlight' },
			{ from: '--main-font', to: '--shelf-2-discount-typography', name: 'Discount' },
			{ from: '--main-font', to: '--shelf-2-name-typography', name: 'Product Name' },
			{ from: '--main-font', to: '--shelf-2-list-typography', name: 'List Price' },
			{ from: '--main-font', to: '--shelf-2-selling-typography', name: 'Selling Price' },
			{ from: '--main-font', to: '--shelf-2-installments-typography', name: 'Installments' },
			{ from: '--main-font', to: '--shelf-2-cta-typography', name: 'CTA' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--shelf-2-lateral-spacing', name: 'Lateral Padding' },
			{ from: '--spacing-nano', to: '--shelf-2-cta-spacing', name: 'CTA Height' },
			{ from: '--spacing-nano', to: '--shelf-2-highlight-spacing', name: 'Highlight Height' },
			{ from: '--spacing-nano', to: '--shelf-2-discount-spacing', name: 'Discount Size' },
		],
	},
];
